import { render, staticRenderFns } from "./managementActivity.vue?vue&type=template&id=6b2afc87&"
import script from "./managementActivity.vue?vue&type=script&lang=js&"
export * from "./managementActivity.vue?vue&type=script&lang=js&"
import style0 from "./managementActivity.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports